<template>
  <router-link class="exam-list-item" tag="div" :to="'/exams/' + data.id">
    <div class="wrapper">
      <div class="flex">
        <div>
          <div class="flex content-start">
            <StudentName v-bind="data.student" hide-age />
            <i class="with anyteachicon anyteach-xunhuan" />
            <div class="teacher">
              <div class="img" :style="$bgd(data.teacher.teacher_gravatar)" />
              <span>{{ data.teacher.teacher_name }}</span>
            </div>
          </div>
          <div class="flex">
            <span class="schedule">{{ data.schedule.title }}</span>
            <span v-if="units" class="units">· {{ units }} 单元</span>
          </div>
          <div class="flex">
            <span class="op">{{ time }}</span>
          </div>
        </div>
        <div class="ratings">
          <span class="star">★</span>
          {{ average }}
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import StudentName from "@/components/public/StudentName"

export default {
  name: "ExamListItem",
  components: {
    StudentName
  },
  props: ["data"],
  computed: {
    time() {
      if (!this.data) return null
      const time = this.$moment(this.data.schedule_time.start_time)
      const now = this.$moment()
      if (time.isBefore(now, "year")) {
        return time.format("YYYY年M月D日 dddd HH:mm")
      } else {
        return time.format("M月D日 dddd HH:mm")
      }
    },
    units() {
      if (!this.data.unit_id.length) return null
      const units = this.data.unit_id.map(unit => unit.title.replace(/[^0-9]/gi, "")).sort()
      if (units.length > 1) {
        return `${units[0]}-${units[units.length - 1]}`
      } else {
        return `${units[0]}`
      }
    },
    average() {
      return (
        (this.data.fluency +
          this.data.accuracy +
          this.data.pronunciation +
          this.data.listening +
          this.data.communication) /
        5
      ).toFixed(1)
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";

.exam-list-item {
  @include card();
  padding: 13px 5%;
  margin: 15px auto 0 auto;
  &:active {
    opacity: 0.6;
  }
  .op {
    opacity: 0.6;
  }

  .units {
    margin-left: 5px;
  }
  .with {
    margin: 0 7px;
    opacity: 0.6;
  }
  .flex {
    font-size: 0.85rem;
  }
  .content-start {
    justify-content: flex-start;
  }
  h4 {
    font-size: 0.85rem;
    font-weight: 400;
  }

  .teacher {
    display: flex;
    align-items: center;
    .img {
      margin-right: 3px;
      $size: 16px;
      width: $size;
      height: $size;
      border-radius: 100%;
    }
  }
}
</style>
